module.exports = __webpack_public_path__ + "img/player_products.1012aa79.png";